<template>
  <div class="DataUpdate">
    <modal
      name="ProgramModal"
      width="80%"
      height="auto"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
    >
      <div class="tabcontent">
        <ValidationObserver ref="obsFieldsUpdate">
          <FormupdatePeriods
            :FieldsForm="formUpdate"
            :ModelForm="formUpdModel"
            :method="executeProcess"
            v-if="renderComponent2"
          />
        </ValidationObserver>
        <div class="modalActions">
          <button
            v-if="!isNew"
            id="updatePeriod"
            class="loginbtn primaryBtn primaryBtn"
            @click="updatePeriod"
          >
            Actualizar
          </button>

          <button
            v-else
            id="AddProgram"
            class="loginbtn primaryBtn primaryBtn"
            @click="AddProgram"
          >
            Guardar
          </button>

          <button
            id="CancelUser"
            class="loginbtn primaryBtn secondaryBtn"
            @click="CancelUser"
          >
            Cancelar
          </button>
        </div>
      </div>
    </modal>

    <div class="titlePage">Administración - Periodos Ibero</div>
    <va-notification color="info" v-if="addRExito" class="refNoData"
      >Se creo correctamente el programa solicitado.</va-notification
    >
    <va-notification color="info" v-if="UpdRExito" class="refNoData"
      >Se actualizo correctamente el programa solicitado.</va-notification
    >
    <va-notification color="danger" v-if="refNoUpdate" class="refNoData"
      >La actualizacion del programa presento un fallo.</va-notification
    >
    <va-notification color="danger" v-if="refWSUpdate" class="refNoData"
      >El servicio que ejecuta la actualización no se encuentra
      activo.</va-notification>

    <ValidationObserver ref="obsFieldsSearch">
      <FormSearchProgram
        :FieldsForm="formSearch"
        :ModelForm="formSchModel"
        :method="executeProcess"
      />
    </ValidationObserver>
    <va-notification color="danger" id="refNoData" class="refNoData noShow"
      >No se encontró información del programa solicitado.</va-notification
    >
    <div class="listPrograms">
      <DataTablePrograms
        :InfoView="this.DLPrograms"
        :HeadTable="this.HDProgram"
        :method="processData"
        v-if="renderComponent1"
      />
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-duplicates
import FormSearchProgram from '@/components/forms/Forms.vue'
// eslint-disable-next-line import/no-duplicates
import FormupdatePeriods from '@/components/forms/Forms.vue'

import Multiselect from 'vue-multiselect'
import IberoHelpers from '@/store/helpers.js'
import DataTablePrograms from '@/components/data-tables/DataCalendarioA.vue'

import Vue from 'vue'
import { DateTimePickerPlugin } from '@syncfusion/ej2-vue-calendars'
Vue.use(DateTimePickerPlugin)

export default {
  name: 'DataUpdate',
  components: {
    DataTablePrograms,
    FormSearchProgram,
    FormupdatePeriods,
    Multiselect,
  },
  data () {
    return {

      ProgramList: IberoHelpers.getPrograms2(this.$store),

      nombre: '',
      AllPgrogram: '',

      // Solo data multiselect
      selected: null,
      value: [],

      options: this.$store.state.ProgramList,

      formSchModel: {},
      formSearch: [
        {
          id: 'Sch_Button',
          type: 'button',
          placeholder: 'Consultar Periodo',
          class: 'col-md-3',
        },
        {
          id: 'Sch_ButtonNew',
          type: 'button',
          placeholder: 'Crear Periodo',
          class: 'col-md-3',
        },
      ],

      formUpdModel: {
        id: 0,
        idp: 0,
        periodO_BANNER: '',
        namProgram: '',
        periodo: '',
        periodO_ANTERIOR: '',
        staActive: '',
        periodO_SIGUIENTE: '',
        fechA_INICIO_PAGO: '',
        fechA_INICIO_PERIODO: '',
        fechA_CORTE: '',
        fechA_FIN_PAGO: '',
        fechA_FIN_PERIODO: '',
        fechA_INICIO_SIGUIENTE_PERIODO: '',
        codigo: '',
        centrO_ESTUDIO: '',
        centrO_ESTUDIO_FUSION_1: '',
        centrO_ESTUDIO_FUSION_2: '',
      },

      formUpdate: [
        {
          id: 'periodO_BANNER',
          model: 'periodO_BANNER',
          valores: true,
          name: 'PERIODO BANNER',
          type: 'input',
          placeholder: 'PERIODO BANNER',
          values: '',
          validate: {
            required: true,
            regex: '^([a-zA-z]?)',
            max: 8,
          },
          class: 'col-md-4',
        },

        {
          id: 'periodo',
          model: 'periodo',
          name: 'PERIODO',
          type: 'input',
          placeholder: 'PERIODO',
          values: '',
          validate: {
            regex: '^([a-zA-z]?)',
            max: 7,
          },
          class: 'col-md-4',
          hidden: true,
        },
        {
          id: 'periodO_ANTERIOR',
          model: 'periodO_ANTERIOR',
          name: 'PERIODO ANTERIOR',
          type: 'input',
          placeholder: '0',
          values: 0,
          validate: {
            regex: '^([a-zA-z]?)',
            max: 7,
          },
          class: 'col-md-4',
        },
        {
          id: 'periodO_SIGUIENTE',
          model: 'periodO_SIGUIENTE',
          name: 'PERIODO SIGUIENTE',
          type: 'input',
          placeholder: '0',
          values: 0,
          validate: {
            regex: '^([a-zA-z]?)',
            max: 7,
          },
          class: 'col-md-4',
        },

        {
          id: 'fechA_INICIO_PAGO',
          model: 'fechA_INICIO_PAGO',
          name: 'FECHA INICIO PAGO',
          placeholder: 'FECHA INICIO PAGO',
          type: 'datepicker',

          dateTimePickerOptions: {
            format: 'yyyy/MM/dd',
            disabledDates: {
            } },
          validate: {
            required: true,
          },
          class: 'col-md-4',
        },

        {
          id: 'staActive',
          model: 'staActive',
          name: 'Estado',
          type: 'Select',
          placeholder: 'Seleccionar...',
          class: 'col-md-4',
          values: [
            { id: 1, value: 'Activos' },
            { id: 0, value: 'Inactivo' },
          ],
          validate: {
            required: true,
          },
        },
        {
          id: 'fechA_INICIO_PERIODO',
          model: 'fechA_INICIO_PERIODO',
          name: 'INICIO PERIODO',
          type: 'datepicker',
          placeholder: 'FECHA INICIO PERIODO',
          dateTimePickerOptions: {
            format: 'yyyy/MM/dd',
            disabledDates: {
            } },
          validate: {
            required: true,
          },
          class: 'col-md-4',
        },
        {
          id: 'fechA_CORTE',
          model: 'fechA_CORTE',
          name: 'FECHA CORTE',
          type: 'datepicker',
          placeholder: 'FECHA CORTE',
          dateTimePickerOptions: {
            format: 'yyyy/MM/dd',
            disabledDates: {
            } },
          validate: {
          },
          class: 'col-md-4',
        },

        {
          id: 'fechA_FIN_PAGO',
          model: 'fechA_FIN_PAGO',
          name: 'FECHA FIN PAGO',
          type: 'datepicker',
          placeholder: 'FECHA FIN PAGO',
          dateTimePickerOptions: {
            format: 'yyyy/MM/dd',
            disabledDates: {
            } },
          validate: {
            required: true,
          },
          class: 'col-md-4',
        },
        {
          id: 'fechA_FIN_PERIODO',
          model: 'fechA_FIN_PERIODO',
          name: 'FECHA FIN PERIODO',
          type: 'datepicker',
          placeholder: 'FECHA_FIN_PERIODO',
          dateTimePickerOptions: {
            format: 'yyyy/MM/dd',
            disabledDates: {
            } },
          validate: {
            required: true,
          },
          class: 'col-md-4',
        },
        {
          id: 'fechA_INICIO_SIGUIENTE_PERIODO',
          model: 'fechA_INICIO_SIGUIENTE_PERIODO',
          name: 'FECHA INICIO SIGUIENTE PERIODO',
          type: 'datepicker',
          placeholder: 'INICIO SIGUIENTE PERIODO',
          dateTimePickerOptions: {
            format: 'yyyy/MM/dd',
            disabledDates: {
            } },
          validate: {
            required: true,
          },
          class: 'col-md-4',
        },
        {
          id: 'codigo',
          model: 'codigo',
          name: 'CODIGO',
          type: 'input',
          placeholder: 'CODIGO',
          values: '',
          validate: {
            max: 15,
          },
          class: 'col-md-4',
        },

        {
          id: 'centrO_ESTUDIO',
          model: 'centrO_ESTUDIO',
          name: 'CENTRO ESTUDIO',
          type: 'Select',
          placeholder: '',
          values: [
            { id: ' ', value: ' ' },
            { id: 'IBERO', value: 'IBERO' },
            { id: 'TOCANCIPA', value: 'TOCANCIPA' },
            { id: 'EDUPOL', value: 'EDUPOL' },
          ],
          validate: {
            max: 15,
          },
          class: 'col-md-4',
        },
        {
          id: 'centrO_ESTUDIO_FUSION_1',
          model: 'centrO_ESTUDIO_FUSION_1',
          name: 'FUSIONADO CON:',
          type: 'Select',
          placeholder: '',
          values: [
            { id: ' ', value: ' ' },
            { id: 'IBERO', value: 'IBERO' },
            { id: 'TOCANCIPA', value: 'TOCANCIPA' },
            { id: 'EDUPOL', value: 'EDUPOL' },
          ],
          validate: {
            max: 15,
          },
          class: 'col-md-4',
        },
        {
          id: 'centrO_ESTUDIO_FUSION_2',
          model: 'centrO_ESTUDIO_FUSION_2',
          name: 'FUSIONADO CON:',
          type: 'Select',
          placeholder: '',
          values: [
            { id: ' ', value: ' ' },
            { id: 'IBERO', value: 'IBERO' },
            { id: 'TOCANCIPA', value: 'TOCANCIPA' },
            { id: 'EDUPOL', value: 'EDUPOL' },
          ],
          validate: {
            max: 15,
          },
          class: 'col-md-4',
        },
      ],

      HDProgram: [

        {
          name: 'periodo',
          title: 'PERIODO BANNER',
          sortField: 'periodo',
          width: '20%',
        },
        {
          name: 'periodO_BANNER',
          title: 'PERIODO',
          sortField: 'periodO_BANNER',
          width: '60%',
        },

        {
          name: 'periodO_ANTERIOR',
          title: 'PERIODO ANTERIOR',
          sortField: 'periodO_ANTERIOR',
          width: '60%',
        },
        {
          name: 'periodO_SIGUIENTE',
          title: 'PERIODO SIGUIENTE',
          sortField: 'periodO_SIGUIENTE',
          width: '20%',
        },
        {
          name: 'fechA_INICIO_PAGO',
          title: 'FECHA INICIO PAGO',
          sortField: 'fechA_INICIO_PAGO',
          width: '60%',
        },

        {
          name: 'fechA_INICIO_PERIODO',
          title: 'FECHA INICIO PERIODO',
          sortField: 'fechA_INICIO_PERIODO',
          width: '20%',
        },
        {
          name: 'fechA_CORTE',
          title: 'FECHA CORTE',
          sortField: 'fechA_CORTE',
          width: '60%',
        },

        {
          name: 'fechA_FIN_PAGO',
          title: 'FECHA FIN PAGO',
          sortField: 'fechA_FIN_PAGO',
          width: '20%',
        },
        {
          name: 'fechA_FIN_PERIODO',
          title: 'FECHA FIN PERIODO',
          sortField: 'fechA_FIN_PERIODO',
          width: '60%',
        },

        {
          name: 'fechA_INICIO_SIGUIENTE_PERIODO',
          title: 'FECHA SIGUIENTE PERIODO',
          sortField: 'fechA_INICIO_SIGUIENTE_PERIODO',
          width: '60%',
        },

        {
          name: 'codigo',
          title: 'CODIGO',
          sortField: 'codigo',
          width: '20%',
        },
        {
          name: 'centrO_ESTUDIO',
          title: 'CENTRO',
          sortField: 'centrO_ESTUDIO',
          width: '60%',
        },

        {
          name: 'centrO_ESTUDIO_FUSION_1',
          title: 'CENTRO F1',
          sortField: 'centrO_ESTUDIO_FUSION_1',
          width: '20%',
        },
        {
          name: 'centrO_ESTUDIO_FUSION_2',
          title: 'CENTRO F1',
          sortField: 'centrO_ESTUDIO_FUSION_2',
          width: '60%',
        },
        {
          name: '__slot:staActive',
          title: 'Activo',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
          actionRef: [
            {
              label: 'Editar',
              icon: 'fa-pencil',
              action: 'edit',
            },
          ],
        },
      ],
      DLPrograms: [],
      renderComponent1: false,
      renderComponent2: false,
      addRExito: false,
      UpdRExito: false,
      refNoUpdate: false,
      refWSUpdate: false,
      isNew: false,
    }
  },
  methods: {
    executeProcess: function (event, refer) {
      this.limpiaref()
      switch (event.target.id) {
        case 'btn_Sch_Button':
          this.isNew = false
          return new Promise((resolve, reject) => {
            this.$refs.obsFieldsSearch.validate().then((results) => {
              if (!results) {
                resolve(false)
              } else {
                this.searchForm()
                resolve(true)
              }
            })
          })
        case 'btn_Sch_ButtonNew': /// /boton mitad
          this.limpiaref()
          this.clearFields()
          this.isNew = true
          IberoHelpers.forceRerender2(this)
          this.$modal.show('ProgramModal')
      }

      this.$refs.obsFieldsSearch.validate()
    },

    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000), /// ////////////metodo el cual add el vector
      }
      this.options.push(tag)
      this.value.push(tag)
    },

    searchForm () {
      document.getElementById('refNoData').classList.add('noShow')
      this.isNew = false
      let loader = this.$loading.show()
      var ListgetCalendarioA = IberoHelpers.getCalendarioA(
        this.$store,
        this.formSchModel,
        0
      )
      this.renderComponent1 = false
      ListgetCalendarioA.then((Response) => {
        if (Response.data === undefined || Response.data === '') {
          document.getElementById('refNoData').classList.remove('noShow')
        } else {
          if (Array.isArray(Response.data)) {
            this.DLPrograms = Response.data
          } else {
            this.DLPrograms = [Response.data]
          }
          IberoHelpers.forceRerender1(this)
        }
        loader.hide()
      })
    },

    updatePeriod () {
      this.limpiaref()
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsUpdate.validate().then((results) => {
          if (!results) {
            resolve(false)
          } else {
            let loader = this.$loading.show()

            var v = JSON.stringify(this.$refs.seleccionado.value)
            this.nombre = v.concat()

            this.formUpdModel.namProgram = this.nombre
            console.log(this.formUpdModel)
            var totalinf = IberoHelpers.updateCalendarioA(
              this.$store,
              this.formUpdModel
            )
            totalinf.then(Response => {
              this.renderComponent1 = false
              if (Response === false) {
                this.refWSUpdate = true
                resolve(false)
              } else if (!(Response.status === 200)) {
                this.refNoUpdate = true
                resolve(false)
              } else {
                this.UpdRExito = true
                resolve(true)
              }
              this.$modal.hide('ProgramModal')

              this.searchForm()
              loader.hide()
              this.value = ''
            })
          }
        })
      })
    },

    AddProgram () {
      this.limpiaref()
      return new Promise((resolve, reject) => {
        this.$refs.obsFieldsUpdate.validate().then((results) => {
          if (!results) {
            resolve(false)
          } else {
            let loader = this.$loading.show()

            var totalinf = IberoHelpers.addPCalendarioA(
              this.$store,
              this.formUpdModel
            )
            totalinf.then((Response) => {
              this.renderComponent1 = false
              if (Response === false) {
                this.refWSUpdate = true
                resolve(false)
              } else if (!(Response.status === 200)) {
                this.refNoUpdate = true
                resolve(false)
              } else {
                this.addRExito = true
                resolve(true)
              }
              this.$modal.hide('ProgramModal')

              this.searchForm()
              loader.hide()
            })
          }
        })
      })
    },

    CancelUser () {
      this.value = ''
      this.limpiaref()
      this.clearFields()
      this.$modal.hide('ProgramModal')
    },
    limpiaref () {
      // this.value = ''
      this.addRExito = false
      this.UpdRExito = false
      this.refNoUpdate = false
      this.refWSUpdate = false
      document.getElementById('refNoData').classList.add('noShow')
    },
    clearFields () {
      this.formUpdModel.id = 0
      this.formUpdModel.reference = 2
      // this.formUpdModel.iD_CALENDAR_PERMANENCIA = "1";
      // this.formUpdModel.programa = "1";
      // this.formUpdModel.codigO_PROGRAMA = "1";
      this.formUpdModel.periodO_BANNER = ''
      this.formUpdModel.staActive = ''
      this.formUpdModel.periodo = ''
      this.formUpdModel.periodO_ANTERIOR = ''
      this.formUpdModel.periodO_SIGUIENTE = ''
      this.formUpdModel.fechA_INICIO_PAGO = ''
      this.formUpdModel.fechA_INICIO_PERIODO = ''
      this.formUpdModel.fechA_CORTE = ''
      this.formUpdModel.fechA_FIN_PAGO = ''
      this.formUpdModel.fechA_FIN_PERIODO = ''
      this.formUpdModel.fechA_INICIO_SIGUIENTE_PERIODO = ''
      this.formUpdModel.codigo = ''
      this.formUpdModel.centrO_ESTUDIO = ''
      this.formUpdModel.centrO_ESTUDIO_FUSION_1 = ''
      this.formUpdModel.centrO_ESTUDIO_FUSION_2 = ''
    },

    processData: function (dataInf, refdata) {
      this.limpiaref()
      this.isNew = false
      debugger
      this.formUpdModel.id = dataInf.id
      this.formUpdModel.idp = dataInf.idp
      this.formUpdModel.reference = 3
      if (dataInf.namProgram === '' || dataInf.namProgram === null) {
        this.formUpdModel.namProgram = this.nombre
      } else {
        this.value = dataInf.namProgram
      }
      this.formUpdModel.iD_CALENDAR_PERMANENCIA =
        dataInf.iD_CALENDAR_PERMANENCIA
      this.formUpdModel.programa = dataInf.programa
      this.formUpdModel.codigO_PROGRAMA = dataInf.codigO_PROGRAMA
      this.formUpdModel.periodO_BANNER = dataInf.periodo
      if (dataInf.staActive === true) {
        this.formUpdModel.staActive = 1
      } else {
        this.formUpdModel.staActive = 0
      }
      this.formUpdModel.periodo = dataInf.periodO_BANNER
      this.formUpdModel.periodO_ANTERIOR = dataInf.periodO_ANTERIOR
      this.formUpdModel.periodO_SIGUIENTE = dataInf.periodO_SIGUIENTE
      this.formUpdModel.fechA_INICIO_PAGO = new Date(dataInf.fechA_INICIO_PAGO)
      // this.formUpdModel.fechA_INICIO_PAGO =  this.formUpdModel.fechA_INICIO_PAGO.toLocaleDateString()

      this.formUpdModel.fechA_INICIO_PERIODO = dataInf.fechA_INICIO_PERIODO
      this.formUpdModel.fechA_CORTE = dataInf.fechA_CORTE
      this.formUpdModel.fechA_FIN_PAGO = dataInf.fechA_FIN_PAGO
      this.formUpdModel.fechA_FIN_PERIODO = dataInf.fechA_FIN_PERIODO
      this.formUpdModel.fechA_INICIO_SIGUIENTE_PERIODO =
        dataInf.fechA_INICIO_SIGUIENTE_PERIODO
      this.formUpdModel.codigo = dataInf.codigo
      this.formUpdModel.centrO_ESTUDIO = dataInf.centrO_ESTUDIO
      this.formUpdModel.centrO_ESTUDIO_FUSION_1 =
        dataInf.centrO_ESTUDIO_FUSION_1
      this.formUpdModel.centrO_ESTUDIO_FUSION_2 =
        dataInf.centrO_ESTUDIO_FUSION_2
      this.formUpdModel.idProgram = dataInf.idProgram
      this.formUpdModel.codProgram = dataInf.codProgram
      IberoHelpers.forceRerender2(this)
      this.$modal.show('ProgramModal')
    },
  },
}
</script>